/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled } from '@mui/material';
import Typography from './Typography';
import { shouldForwardProp } from '../util/helpers';

interface ItemContainerProps extends Record<string, unknown> {
  wrap?: boolean;
}

export const ItemContainer = styled('div', {
  shouldForwardProp: (prop) => shouldForwardProp<ItemContainerProps>(['wrap'], prop),
})<ItemContainerProps>(({ theme, wrap }) => ({
  display: 'flex',

  [theme.breakpoints.down('sm')]: {
    columnGap: '8px',
    width: 'unset',
  },

  ...(!wrap
    ? {
        flexDirection: 'column',
      }
    : {
        flexDirection: 'row',
        flexWrap: 'wrap',
      }),
}));

export const ItemLabel = styled(Typography)(({ theme, color, align }) => ({
  color: theme.colors[color ?? 'grey700'],
  textAlign: align,
  whiteSpace: 'nowrap',
}));

export const ItemValue = styled(Typography)(({ theme, color, align }) => ({
  color: theme.colors[color ?? 'grey700'],
  textAlign: align,
}));
